<mat-tab-group>
  <mat-tab label="Robot">
    <!-- TAB 1 Tundish 1-->
    <div style="margin: 20px">
      <mat-grid-list cols="3" rowHeight="2:1">
        <mat-grid-tile>
          <mat-card style="width: 100%; margin: 5px">
            <mat-card-title style="padding: 10px 0 0px 20px">
              Operation
              <button
                *ngIf="dashboard.data.robot.operation.screen"
                mat-raised-button
                color="primary"
                style="margin-right: 10px"
              >
                Screen
              </button>
              <button
                *ngIf="dashboard.data.robot.operation.automatic"
                mat-raised-button
                color="accent"
                style="margin-right: 10px"
              >
                Automatic
              </button>
              <button
                *ngIf="dashboard.data.robot.operation.manual"
                mat-raised-button
                color="warn"
                style="margin-right: 10px"
              >
                Manual
              </button>
            </mat-card-title>
            <mat-card-subtitle
              style="padding: 0px 0 0px 20px"
            ></mat-card-subtitle>
            <mat-card-content style="padding: 0px 0 20px 20px">
              <img
                src="../../../assets/images/robot_machine.png"
                alt=""
                style="width: 50%"
              />
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="width: 100%; margin: 5px">
            <mat-card-title style="padding: 10px 0 0px 20px"
              >Head</mat-card-title
            >
            <mat-card-subtitle
              style="padding: 0px 0 0px 20px"
            ></mat-card-subtitle>
            <mat-card-content>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">TURN</div>
                <button
                  *ngIf="dashboard.data.robot.head.turn.clockwise"
                  mat-raised-button
                  color="primary"
                  style="margin: 0 5px"
                >
                  Clockwise
                </button>
                <button
                  *ngIf="dashboard.data.robot.head.turn.anticlockwise"
                  mat-raised-button
                  color="accent"
                  style="margin: 0 5px"
                >
                  Anticlockwise
                </button>
                <button
                  *ngIf="
                    !dashboard.data.robot.head.turn.anticlockwise &&
                    !dashboard.data.robot.head.turn.clockwise
                  "
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  N/A
                </button>
                <div style="padding: 10px 0">POSITION</div>
                <button mat-raised-button color="primary" style="margin: 0 5px">
                  {{ dashboard.data.robot.head.turn.position }}
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">ELEVATION</div>
                <button
                  *ngIf="dashboard.data.robot.head.elevation.up"
                  mat-raised-button
                  color="primary"
                  style="margin: 0 5px"
                >
                  UP
                </button>
                <button
                  *ngIf="dashboard.data.robot.head.elevation.down"
                  mat-raised-button
                  color="accent"
                  style="margin: 0 5px"
                >
                  DOWN
                </button>
                <button
                  *ngIf="
                    !dashboard.data.robot.head.elevation.up &&
                    !dashboard.data.robot.head.elevation.down
                  "
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  N/A
                </button>
                <div style="padding: 10px 0">POSITION</div>
                <button mat-raised-button color="primary" style="margin: 0 5px">
                  {{ dashboard.data.robot.head.elevation.position }}
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">HEAD ELEVATION UP</div>
                <!-- <button
                  *ngIf="dashboard.data.robot.furnace.head.elevation.up"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button> -->
                <button
                  *ngIf="dashboard.data.robot.furnace.head.elevation"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button>
                <!-- <button
                  *ngIf="!dashboard.data.robot.furnace.head.elevation.up"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button> -->
                <button
                  *ngIf="dashboard.data.robot.furnace.head.elevation === false"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button>
                <div style="padding: 10px 0">HEAD TURN ORIGIN</div>
                <button
                  *ngIf="dashboard.data.robot.furnace.head.origin"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button>
                <button
                  *ngIf="!dashboard.data.robot.furnace.head.origin"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button>
              </div>
              <div style="clear: both"></div>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="width: 100%; margin: 5px">
            <mat-card-title style="padding: 10px 0 0px 20px"
              >Mast</mat-card-title
            >
            <mat-card-subtitle
              style="padding: 0px 0 0px 20px"
            ></mat-card-subtitle>
            <mat-card-content>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">TURN</div>
                <button
                  *ngIf="dashboard.data.robot.mast.turn.clockwise"
                  mat-raised-button
                  color="primary"
                  style="margin: 0 5px"
                >
                  Clockwise
                </button>
                <button
                  *ngIf="dashboard.data.robot.mast.turn.anticlockwise"
                  mat-raised-button
                  color="accent"
                  style="margin: 0 5px"
                >
                  Anticlockwise
                </button>
                <button
                  *ngIf="
                    !dashboard.data.robot.mast.turn.anticlockwise &&
                    !dashboard.data.robot.mast.turn.clockwise
                  "
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  N/A
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">ELEVATION</div>
                <button
                  *ngIf="dashboard.data.robot.mast.elevation.up"
                  mat-raised-button
                  color="primary"
                  style="margin: 0 5px"
                >
                  UP
                </button>
                <button
                  *ngIf="dashboard.data.robot.mast.elevation.down"
                  mat-raised-button
                  color="primary"
                  style="margin: 0 5px"
                >
                  DOWN
                </button>
                <button
                  *ngIf="
                    !dashboard.data.robot.mast.elevation.up &&
                    !dashboard.data.robot.mast.elevation.down
                  "
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  N/A
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">MAST ELEVATION UP</div>
                <!-- <button
                  *ngIf="dashboard.data.robot.furnace.mast.elevation.up"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button> -->
                <button
                  *ngIf="dashboard.data.robot.furnace.mast.elevation"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button>
                <!-- <button
                  *ngIf="!dashboard.data.robot.furnace.mast.elevation.up"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button> -->
                <button
                  *ngIf="dashboard.data.robot.furnace.mast.elevation === false"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">MAST TURN PARKING</div>
                <button
                  *ngIf="dashboard.data.robot.furnace.mast.parking"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  YES
                </button>
                <button
                  *ngIf="!dashboard.data.robot.furnace.mast.parking"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  NO
                </button>
              </div>
              <div style="clear: both"></div>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="width: 100%; margin: 5px">
            <mat-card-title style="padding: 10px 0 0px 20px"
              >Water</mat-card-title
            >
            <mat-card-subtitle
              style="padding: 0px 0 0px 20px"
            ></mat-card-subtitle>
            <mat-card-content>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">MAXIMUM LEVEL</div>
                <button
                  *ngIf="!dashboard.data.robot.water.level.max"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  OK
                </button>
                <button
                  *ngIf="dashboard.data.robot.water.level.max"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  ERROR
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">MINIMUM LEVEL</div>
                <button
                  *ngIf="!dashboard.data.robot.water.level.min"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  OK
                </button>
                <button
                  *ngIf="dashboard.data.robot.water.level.min"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  ERROR
                </button>
              </div>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 33%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">EV INPUT</div>
                <button
                  *ngIf="!dashboard.data.robot.water.level.evinput"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  Opened
                </button>
                <button
                  *ngIf="dashboard.data.robot.water.level.evinput"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  Closed
                </button>
              </div>
              <div
                style="
                  text-align: center;
                  width: 100%;
                  clear: both;
                  padding: 10px;
                "
              >
                <div style="padding-bottom: 10px">LITERS</div>
                <div
                  style="
                    padding: 10px;
                    background-color: #ededed;
                    border-radius: 25px;
                    border: 3px solid #73ad21;
                    font-size: 20px;
                  "
                >
                  {{ dashboard.data.robot.water.liters }}
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile>
          <mat-card style="width: 100%; margin: 5px">
            <mat-card-title style="padding: 10px 0 0px 20px"
              >Hydraulic Group</mat-card-title
            >
            <mat-card-subtitle
              style="padding: 0px 0 0px 20px"
            ></mat-card-subtitle>
            <mat-card-content>
              <div
                style="
                  float: left;
                  text-align: center;
                  width: 25%;
                  padding-bottom: 10px;
                "
              >
                <div style="padding-bottom: 10px">MOTOR</div>
                <button
                  *ngIf="dashboard.data.robot.hydraulic.motor"
                  mat-raised-button
                  color="primary"
                  style="background-color: green; margin: 0 5px"
                >
                  ON
                </button>
                <button
                  *ngIf="!dashboard.data.robot.hydraulic.motor"
                  mat-raised-button
                  color="warn"
                  style="margin: 0 5px"
                >
                  OFF
                </button>
              </div>
              <div style="clear: both"></div>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
      <mat-card>
        <mat-card-title style="padding: 10px 0 0px 20px"
          >Variables del Proceso</mat-card-title
        >
        <mat-card-subtitle style="padding: 0px 0 0px 20px"
          >Tablón</mat-card-subtitle
        >
        <mat-card-content>
          <table
            mat-table
            matSort
            [dataSource]="dataSourceRobotProcessVariables"
            class="mat-elevation-z8"
          >
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="uuid">
              <th mat-header-cell *matHeaderCellDef style="text-align: center">
                UUID
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ element.uuid }}
              </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef style="text-align: center">
                Nombre
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ element.nombre }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="fecha">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="text-align: center"
              >
                Fecha
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ doTransformDate(element.fecha) }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="valor">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="text-align: center"
              >
                Activo
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                <button
                  *ngIf="element.valor"
                  color="primary"
                  mat-raised-button
                  style="background-color: green"
                >
                  SÍ</button
                ><button
                  *ngIf="!element.valor"
                  mat-raised-button
                  color="primary"
                  style="background-color: red"
                >
                  NO
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsRobotProcessVariables"
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: displayedColumnsRobotProcessVariables
              "
            ></tr>
          </table>
          <mat-paginator
            #paginatorRobotProcessVariables
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab label="Gunning Machine">
    <div style="margin: 20px">
      <div style="float: left; width: 45%; margin-right: 5px">
        <div style="text-align: center; margin-bottom: 10px">
          Gunning Machine 1
        </div>
        <div style="float: left; width: 43%">
          <img
            src="../../../assets/images/gunning_machine.png"
            alt=""
            style="width: 90%"
          />
        </div>
        <mat-card
          style="
            width: 20%;
            float: left;
            margin-bottom: 10px;
            margin-right: 10px;
          "
        >
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Operation</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 20px">
            <button
              *ngIf="dashboard.data.gunning.operation.screen"
              mat-raised-button
              color="primary"
              style="margin-right: 10px"
            >
              Screen
            </button>
            <button
              *ngIf="dashboard.data.gunning.operation.automatic"
              mat-raised-button
              color="accent"
              style="margin-right: 10px"
            >
              Automatic
            </button>
            <button
              *ngIf="dashboard.data.gunning.operation.manual"
              mat-raised-button
              color="warn"
              style="margin-right: 10px"
            >
              Manual
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 25%; float: left; margin-bottom: 10px">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Product</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <div
              style="
                padding: 10px;
                background-color: #ededed;
                border-radius: 25px;
                border: 3px solid #73ad21;
                font-size: 20px;
                text-align: center;
              "
            >
              Kgs<br />
              33
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 50%; float: left; margin-bottom: 10px">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Pressure</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 20px">
            <div
              style="
                float: left;
                text-align: center;
                width: 30%;
                padding-bottom: 10px;
              "
            >
              <div style="padding-bottom: 10px">CHARGE</div>
              <mat-icon
                *ngIf="dashboard.data.robot.hydraulic.evblock"
                style="color: red; font-size: 30px"
                >error</mat-icon
              >
              <mat-icon
                *ngIf="!dashboard.data.robot.hydraulic.evblock"
                style="color: green; font-size: 30px"
                >check_circle</mat-icon
              >
            </div>
            <div
              style="
                float: left;
                text-align: center;
                width: 30%;
                padding-bottom: 10px;
              "
            >
              <div style="padding-bottom: 10px">GUNNING</div>
              <mat-icon
                *ngIf="dashboard.data.robot.hydraulic.evsecurity"
                style="color: red; font-size: 30px"
                >error</mat-icon
              >
              <mat-icon
                *ngIf="!dashboard.data.robot.hydraulic.evsecurity"
                style="color: green; font-size: 30px"
                >check_circle</mat-icon
              >
            </div>
            <div style="float: left; width: 30%; margin: 0 10px">
              <div
                style="
                  padding: 10px;
                  background-color: #ededed;
                  border-radius: 25px;
                  border: 3px solid #73ad21;
                  font-size: 20px;
                  text-align: center;
                "
              >
                Bar<br />
                33
              </div>
            </div>
            <div style="clear: both"></div>
          </mat-card-content>
        </mat-card>
        <div style="clear: both"></div>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px">LID</mat-card-title>
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.lid.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.lid.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vibrator</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vibrator.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.vibrator.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Pressure</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.pressure.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.pressure.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Venting</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.venting.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.venting.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Transport</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.transport.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.transport.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Load</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.load.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.load.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Discharge</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.discharge.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.discharge.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
      </div>
      <div style="float: left; width: 45%; margin-right: 5px">
        <div style="text-align: center; margin-bottom: 10px">
          Gunning Machine 2
        </div>
        <div style="float: left; width: 43%">
          <img
            src="../../../assets/images/gunning_machine.png"
            alt=""
            style="width: 90%"
          />
        </div>
        <mat-card
          style="
            width: 20%;
            float: left;
            margin-bottom: 10px;
            margin-right: 10px;
          "
        >
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Operation</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 20px">
            <button
              *ngIf="dashboard.data.gunning.operation.screen"
              mat-raised-button
              color="primary"
              style="margin-right: 10px"
            >
              Screen
            </button>
            <button
              *ngIf="dashboard.data.gunning.operation.automatic"
              mat-raised-button
              color="accent"
              style="margin-right: 10px"
            >
              Automatic
            </button>
            <button
              *ngIf="dashboard.data.gunning.operation.manual"
              mat-raised-button
              color="warn"
              style="margin-right: 10px"
            >
              Manual
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 25%; float: left; margin-bottom: 10px">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Product</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <div
              style="
                padding: 10px;
                background-color: #ededed;
                border-radius: 25px;
                border: 3px solid #73ad21;
                font-size: 20px;
                text-align: center;
              "
            >
              Kgs<br />
              33
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 50%; float: left; margin-bottom: 10px">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Pressure</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 20px">
            <div
              style="
                float: left;
                text-align: center;
                width: 30%;
                padding-bottom: 10px;
              "
            >
              <div style="padding-bottom: 10px">CHARGE</div>
              <mat-icon
                *ngIf="dashboard.data.robot.hydraulic.evblock"
                style="color: red; font-size: 30px"
                >error</mat-icon
              >
              <mat-icon
                *ngIf="!dashboard.data.robot.hydraulic.evblock"
                style="color: green; font-size: 30px"
                >check_circle</mat-icon
              >
            </div>
            <div
              style="
                float: left;
                text-align: center;
                width: 30%;
                padding-bottom: 10px;
              "
            >
              <div style="padding-bottom: 10px">GUNNING</div>
              <mat-icon
                *ngIf="dashboard.data.robot.hydraulic.evsecurity"
                style="color: red; font-size: 30px"
                >error</mat-icon
              >
              <mat-icon
                *ngIf="!dashboard.data.robot.hydraulic.evsecurity"
                style="color: green; font-size: 30px"
                >check_circle</mat-icon
              >
            </div>
            <div style="float: left; width: 30%; margin: 0 10px">
              <div
                style="
                  padding: 10px;
                  background-color: #ededed;
                  border-radius: 25px;
                  border: 3px solid #73ad21;
                  font-size: 20px;
                  text-align: center;
                "
              >
                Bar<br />
                33
              </div>
            </div>
            <div style="clear: both"></div>
          </mat-card-content>
        </mat-card>
        <div style="clear: both"></div>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px">LID</mat-card-title>
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.lid.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.lid.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vibrator</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vibrator.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.vibrator.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Pressure</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.pressure.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.pressure.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Venting</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.venting.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.venting.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Transport</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.transport.on"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              ON
            </button>
            <button
              *ngIf="dashboard.data.gunning.transport.off"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              OFF
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Load</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.load.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.load.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
        <mat-card style="width: 30%; float: left; margin: 0 10px 10px 0">
          <mat-card-title style="padding: 10px 0 0px 20px"
            >Vessel Discharge</mat-card-title
          >
          <mat-card-subtitle
            style="padding: 0px 0 0px 20px"
          ></mat-card-subtitle>
          <mat-card-content style="padding: 0px 0 20px 0px; margin: 0 10px">
            <button
              *ngIf="dashboard.data.gunning.vessel.discharge.open"
              mat-raised-button
              color="primary"
              style="background-color: green; margin-right: 10px"
            >
              Opened
            </button>
            <button
              *ngIf="dashboard.data.gunning.vessel.discharge.close"
              mat-raised-button
              color="primary"
              style="background-color: red; margin-right: 10px"
            >
              Closed
            </button>
          </mat-card-content>
        </mat-card>
      </div>
      <div style="clear: both"></div>
      <mat-card>
        <mat-card-title style="padding: 10px 0 0px 20px"
          >Variables del Proceso</mat-card-title
        >
        <mat-card-subtitle style="padding: 0px 0 0px 20px"
          >Tablón</mat-card-subtitle
        >
        <mat-card-content>
          <table
            mat-table
            matSort
            [dataSource]="dataSourceGunningMachineProcessVariables"
            class="mat-elevation-z8"
          >
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="uuid">
              <th mat-header-cell *matHeaderCellDef style="text-align: center">
                UUID
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ element.uuid }}
              </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef style="text-align: center">
                Nombre
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ element.nombre }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="fecha">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="text-align: center"
              >
                Fecha
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                {{ doTransformDate(element.fecha) }}
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="valor">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                style="text-align: center"
              >
                Activo
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: center">
                <button
                  *ngIf="element.valor"
                  color="primary"
                  mat-raised-button
                  style="background-color: green"
                >
                  SÍ</button
                ><button
                  *ngIf="!element.valor"
                  mat-raised-button
                  color="primary"
                  style="background-color: red"
                >
                  NO
                </button>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsGunningMachineProcessVariables"
            ></tr>
            <tr
              mat-row
              *matRowDef="
                let row;
                columns: displayedColumnsGunningMachineProcessVariables
              "
            ></tr>
          </table>
          <mat-paginator
            #paginatorGunningMachineProcessVariables
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>
